/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {DatasetColumnMappingOut} from './DatasetColumnMappingOut';
import {
  DatasetColumnMappingOutFromJSON,
  DatasetColumnMappingOutFromJSONTyped,
  DatasetColumnMappingOutToJSON
} from './DatasetColumnMappingOut';

/**
 *
 * @export
 * @interface DatasetColumnsMappings
 */
export interface DatasetColumnsMappings {
  /**
   *
   * @type {Array<DatasetColumnMappingOut>}
   * @memberof DatasetColumnsMappings
   */
  mappings: Array<DatasetColumnMappingOut>;
}

/**
 * Check if a given object implements the DatasetColumnsMappings interface.
 */
export function instanceOfDatasetColumnsMappings(value: object): value is DatasetColumnsMappings {
  if (!('mappings' in value) || value['mappings'] === undefined) return false;
  return true;
}

export function DatasetColumnsMappingsFromJSON(json: any): DatasetColumnsMappings {
  return DatasetColumnsMappingsFromJSONTyped(json, false);
}

export function DatasetColumnsMappingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DatasetColumnsMappings {
  if (json == null) {
    return json;
  }
  return {
    mappings: (json['mappings'] as Array<any>).map(DatasetColumnMappingOutFromJSON)
  };
}

export function DatasetColumnsMappingsToJSON(value?: DatasetColumnsMappings | null): any {
  if (value == null) {
    return value;
  }
  return {
    mappings: (value['mappings'] as Array<any>).map(DatasetColumnMappingOutToJSON)
  };
}
